// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React, { Component } from 'react';
import _ from 'underscore';

import { recupWithHelpers } from 'app/scripts/views/internal/recupWithHelpers';
import { PowerUpItemType } from 'app/src/components/PowerUp';
import { BaseDirectoryView } from './BaseDirectoryView';
import { DirectoryPluginItemView } from './DirectoryPluginItemView';
const t = recupWithHelpers('directory');

class DirectoryPageComponent extends Component {
  static initClass() {
    // @ts-expect-error TS(2339): Property 'displayName' does not exist on type 'Dir... Remove this comment to see the full error message
    this.prototype.displayName = 'Directory Page';

    this.prototype.render = t.renderable(() =>
      t.div('.directory-content-body', () => {
        return t.div('.directory-listing');
      }),
    );
  }
}

DirectoryPageComponent.initClass();

interface DirectoryPageView extends BaseDirectoryView {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  appendSubviews: any;
}
class DirectoryPageView extends BaseDirectoryView {
  eventSource() {
    const { title } = this.options;
    if (title === 'custom') {
      return 'boardDirectoryCustomScreen';
    } else if (title === 'made-by-trello') {
      return 'boardDirectoryMadeByTrelloScreen';
    } else {
      return 'boardDirectoryCategoryScreen';
    }
  }

  renderContent() {
    // @ts-expect-error TS(2769): No overload matches this call.
    return <DirectoryPageComponent title={this.options.title} />;
  }

  render() {
    // @ts-expect-error TS(2556): A spread argument must either have a tuple type or... Remove this comment to see the full error message
    super.render(...arguments);
    const contentContainer = this.$el.find('.directory-listing');
    contentContainer.empty();

    const { plugins, currentPage, directoryView, title } = this.options;

    const pluginViews = _.map(plugins, (plugin) => {
      return this.subview(
        DirectoryPluginItemView,
        this.model,
        {
          atomType: PowerUpItemType.Description,
          currentPage,
          plugin,
          directoryView,
        },
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        plugin.id,
      );
    });

    this.appendSubviews(pluginViews, contentContainer);

    const enabledPlugins = directoryView.getEnabledPlugins();
    const listedPowerUpsEnabled = _.intersection(
      _.map(plugins, 'id'),
      _.map(enabledPlugins, 'id'),
    );

    const eventPayload = {
      totalListed: plugins.length,
      totalListedEnabled: listedPowerUpsEnabled.length,
      totalEnabled: enabledPlugins.length,
      allPowerUpsEnabled: _.map(enabledPlugins, 'id'),
      listedPowerUpsEnabled,
    };

    const eventName = this.eventSource();
    if (title !== 'custom') {
      // @ts-expect-error TS(2339): Property 'categoryid' does not exist on type '{ to... Remove this comment to see the full error message
      eventPayload.categoryid = title;
    }

    directoryView.trackScreenEvent(eventName, eventPayload);

    return this;
  }
}

export { DirectoryPageView };
